<app-nav-bar></app-nav-bar>
<div class="scheduleConference">
  <div class="split left">
    <br>
    <br>
      <span style="font-size: 25px;font-weight: 600;color: #004526;font-family: 'Rubik', sans-serif;">
         Conference Schedule Preview
        </span>
        <br>
        <br>
    
        <table class="table table-bordered">   
          <tbody>
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Meeting Id </td>
              <td style="font-size: 18px;font-weight: 400;">{{randomIDs}}</td>
              
            </tr>
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Meeting Password</td>
              <td style="font-size: 18px;font-weight: 400;">{{randomPasswords}}</td>
              
            </tr>
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Event Title Name</td>
              <td style="font-size: 18px;font-weight: 400;">{{model.eventTitleC}}</td>         
            </tr>
            <tr>
              <td style="font-size: 20px;font-weight: 500;">From</td>
              <td style="font-size: 18px;font-weight: 400;">{{from}}</td>         
            </tr>
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Group Name</td>
              <td style="font-size: 18px;font-weight: 400;"><p><span *ngFor="let grpName of selectedGroup"> {{grpName.groupName}} ,</span></p></td>         
            </tr>
            
    
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Module</td>
              <td style="font-size: 18px;font-weight: 400;">{{module}}</td>         
            </tr>
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Department Name</td> 
              <td style="font-size: 18px;font-weight: 400;"><p  ><span *ngFor="let dept of selectedID"> {{dept.deptName}} ,</span></p></td> 
              <!-- <span>{{model.erpDept}}</span> -->
             
              <!-- <td style="font-size: 18px;font-weight: 400;">{{selectedDeptName}}</td>          -->
            </tr>
    
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Taken By</td>
              <td style="font-size: 18px;font-weight: 400;">{{takenByName}}</td>         
            </tr>
           
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Course Name</td>
              <td style="font-size: 18px;font-weight: 400;">{{selectedCourseName}}</td>
             
            </tr>
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Session </td>
              <td style="font-size: 18px;font-weight: 400;">{{selectedSession}} </td>         
            </tr>
            <!-- <tr>
              <td style="font-size: 20px;font-weight: 500;">Student Name </td>
              <td style="font-size: 18px;font-weight: 400;">selectedStudentName </td>         
            </tr> -->
           
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Member's Name</td>
             <td style="width: 504px;">
    
    <div style="width:504px; height:290px; overflow:auto;">
    <table class="table table-bordered" cellspacing="0" cellpadding="1" width="504px" >
    <tr *ngFor="let memeber of stuinfonewName">
      <td>
    {{memeber.webinarAttendeeName}}
      </td>
      <td >
        <i class="fas fa-trash" style="color: red;margin-left: 70px;cursor: pointer;" (click)="deleteMemeber(index)"></i>
      </td>
    </tr>
    </table>
    </div>
             </td>
            </tr>
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Start Date</td>
              <td style="font-size: 18px;font-weight: 400;">{{model.startDateC}}</td>
              
            </tr>
            <tr>
              <td style="font-size: 20px;font-weight: 500;">End Date</td>
              <td style="font-size: 18px;font-weight: 400;">{{model.endDateC}}</td>
              
            </tr>
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Start Time</td>
              <td style="font-size: 18px;font-weight: 400;">{{model.startTimeC}}</td>
              
            </tr>
            <tr>
              <td style="font-size: 20px;font-weight: 500;">End Time</td>
              <td style="font-size: 18px;font-weight: 400;">{{model.endTimeC}}</td>
              
            </tr>
            <tr>
              <td style="font-size: 20px;font-weight: 500;">Note</td>
              <td style="font-size: 18px;font-weight: 400;">{{model.noteC}}</td>
              
            </tr> 
        </table>
    
    
    </div>
    <div class="split right"> 
        <br>
        <br>
        <span style="font-size: 25px;font-weight: 600;color: #004526; margin-left: 10px;font-family: 'Rubik', sans-serif;">Create Conference Schedule</span>
        <br>
        <br>
        <!-- <div class="row"> -->
            <div class="col-md-12">
                <form name="form" (ngSubmit)="f.form.valid && createMeeting()" #f="ngForm" novalidate>
                    <div class="form-group">
                        <input type="text" id="eventTitle" class="form-control" name="eventTitleC" placeholder="&#xf0c9;&nbsp;&nbsp;Event Title" 
                        style="font-family: FontAwesome;" 
                        [(ngModel)]="model.eventTitleC" #eventTitleC="ngModel" 
                        [ngClass]="{ 'is-invalid': f.submitted && eventTitleC.invalid }" required />
                        <div *ngIf="f.submitted && eventTitleC.invalid" class="invalid-feedback">
                            <div *ngIf="eventTitleC.errors.required">Event Title is required</div>
                        </div>
                    </div>  

                    <div class="group">
                        <span style="font-size: 23px;font-weight: 500;">
                            <span> Group </span>
                          <input type="radio" id="web" name="group" (click)="showGroup()" value="Group">&nbsp;&nbsp;
                          <span> Organization </span>                         
                          <input type="radio" id="meet" name="group" (click)="showOrganization()" value="Organization">                         
                        </span>
                      </div>  
                      <br>

                      <div *ngIf="isShowGroup">
                        <br>
                        <span><p><span *ngFor="let grpName of selectedGroup"> {{grpName.groupName}} ,</span></p></span> 
                        <span id="departmentDDL" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#exampleModalCenter2" style="cursor: pointer;">
                          &nbsp;<i class="fas fa-users" style="color: #004526; font-size: 20px;" aria-hidden="true"> </i>&nbsp;       
                          <input type="text" id="DDL"  placeholder="Select Group" disabled>
                        </span>
                        <br>
                        <br>
                        
                        <span id="departmentDDL">
                          &nbsp;<i class="fas fa-user" style="color: #004526; font-size: 20px;" aria-hidden="true"></i>&nbsp;&nbsp;                         
                          <select name="selectDepartment" id="departmentDDL" class="caret" id="DDL"  [(ngModel)]="takenBy" (change)="takenByGroupMember(stuinfonewName);">
                            <option [ngValue]='0'>Select Taken By</option>
                            <option *ngFor="let order of stuinfonewName" [value]="order.webinarAttendee">{{order.webinarAttendeeName}}</option>
                            </select>
                        </span>

                        </div>   

                        <div *ngIf="isShowOrganization">
                            <div class="group3">
                                <span>
                                <span>
                                  <i class="fas fa-users" style="color: #87b538; font-size: 22px;" aria-hidden="true"> </i>
                                </span>
                                &nbsp;&nbsp;
                                  <span style="font-size: 20px;font-weight: 500;">ERP&nbsp;&nbsp;<input type="radio" id="meet" (click)="showErp()" name="erp" value="ERP"></span>
                                  &nbsp;&nbsp;&nbsp;
                                  <span>
                                    <i class="fas fa-mail-bulk" style="color: #87b538; font-size: 22px;" aria-hidden="true"> </i>
                                  </span>
                                  &nbsp;&nbsp;
                                    <span style="font-size: 20px;font-weight: 500;">SMS&nbsp;&nbsp;<input type="radio" id="meet" (click)="showSms()" name="erp" value="SMS"></span>
                                   <span></span>
                            
                                </span>
                              </div>
                              <br>
                              <div *ngIf="isShowErp">   
                                <br>
                                <span><p><span *ngFor="let dept of selectedID"> {{dept.deptName}} ,</span></p></span>          
                                <span id="departmentDDL" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#exampleModalCenter1" style="cursor: pointer;">
                                  
                                  &nbsp;<i class="fas fa-th-list" style="color: #004526; font-size: 20px;" aria-hidden="true"> </i>&nbsp;
                                  <input type="text" id="DDL" placeholder="Select Department" disabled>                                


                                </span>
                                <br>
                                <br>
                                
                                <span id="departmentDDL">
                                  &nbsp;<i class="fas fa-user" style="color: #004526; font-size: 20px;" aria-hidden="true"></i>&nbsp;&nbsp;                                  

                                  <select name="selectDepartment" id="departmentDDL" [(ngModel)]="takenBy" class="caret" id="DDL" (change)="takenByEmp(stuinfonewName)">
                                    <option [ngValue]='0'>Select User</option>
                                    <option *ngFor="let order of stuinfonewName;" [value]="order.webinarAttendee">{{order.webinarAttendeeName}}</option>
                                    </select>

                                </span>
                                
                                </div>

                                <div *ngIf="isShowSms">
                                    <span id="departmentDDL">
                                      &nbsp;<i class="fas fa-th-list" style="color: #004526; font-size: 20px;" aria-hidden="true"> </i>&nbsp;
                                     
                                      <select name="selectDepartment" id="DDL" [(ngModel)]="course" (change)="getCourseName(courseList)">
                                        <option [ngValue]='0'>Select Courses</option>
                                        <option *ngFor="let order of courseList;" [value]="order.id">{{order.name}}</option>
                                        </select>
                                        
                                    </span>
                                    <br>
                                    <br>
                                    <span id="departmentDDL">
                                      &nbsp;<i class="fa fa-calendar" style="color: #004526; font-size: 20px;" aria-hidden="true"></i>&nbsp;&nbsp;
                                      
                                      <select name="selectDepartment" id="departmentDDL" class="caret" id="DDL" [(ngModel)]="session" (change)="getSessionName(sessionList);">
                                        <option [ngValue]='0'>Select Session</option>
                                        <option *ngFor="let order of sessionList;" [value]="order.id">{{order.session}}</option>
                                        </select>
                                    
                                    </span>
                                    <br>
                                    <br>
                                    <span id="departmentDDL">
                                      &nbsp;<i class="fas fa-user" style="color: #004526; font-size: 20px;" aria-hidden="true"></i>&nbsp;&nbsp;
                                     

                                      <select name="selectDepartment" id="departmentDDL" class="caret" id="DDL" [(ngModel)]="takenBy" (change)="takenByFaculty(facultyList);">
                                        <option [ngValue]='0'>Select Faculty</option>
                                        <option *ngFor="let order of stuinfonewName;" [value]="order.webinarAttendee">{{order.webinarAttendeeName}}</option>
                                        </select>
                                    
                                    </span>
                                    <br>
                                    <br>
                                    
                                    </div>

                        </div>

                      <br>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <input type="date" class="form-control" name="startDateC" placeholder="Start Date"
                            style="font-family: FontAwesome;
                            height: 70px;
                            border-radius: 10px;
                            border: 2px solid #CDCDCD;
                            padding: 0 20px;
                            font-size: 20px;
                            font-weight: 400;"                
                            [(ngModel)]="model.startDateC" #startDateC="ngModel" [ngClass]="{ 'is-invalid': f.submitted && startDateC.invalid }" required />
                            <div *ngIf="f.submitted && startDateC.invalid" class="invalid-feedback">
                                <div *ngIf="startDateC.errors.required">Start Date is required</div>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-6">
                        <!-- <input type="text" id="date1" name="date1"/> <br/> -->
                        <div class="form-group">                         
                            <input type="date" class="form-control" name="endDateC" placeholder="End Date"
                            style="font-family: FontAwesome;
                            height: 70px;
                            border-radius: 10px;
                            border: 2px solid #CDCDCD;
                            padding: 0 20px;
                            font-size: 20px;
                            font-weight: 400;" 
                            [(ngModel)]="model.endDateC" #endDateC="ngModel" [ngClass]="{ 'is-invalid': f.submitted && endDateC.invalid }" required />
                            <div *ngIf="f.submitted && endDateC.invalid" class="invalid-feedback">
                                <div *ngIf="endDateC.errors.required">End Date  is required</div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">    
                            <input type="time" class="form-control" name="startTimeC" placeholder="End Date"
                            style="font-family: FontAwesome;
                            height: 70px;
                            border-radius: 10px;
                            border: 2px solid #CDCDCD;
                            padding: 0 20px;
                            font-size: 20px;
                            font-weight: 400;" 
                            [(ngModel)]="model.startTimeC" #startTimeC="ngModel" [ngClass]="{ 'is-invalid': f.submitted && startTimeC.invalid }" required />
                            <div *ngIf="f.submitted && startTimeC.invalid" class="invalid-feedback">
                                <div *ngIf="startTimeC.errors.required">Start Time is required</div>
                            </div>             
                           
                        </div>

                    </div>
                    <div class="col-md-6">
                        <div class="form-group">

                            <input type="time" class="form-control" name="endTimeC" placeholder="End Date"
                            style="font-family: FontAwesome;
                            height: 70px;
                            border-radius: 10px;
                            border: 2px solid #CDCDCD;
                            padding: 0 20px;
                            font-size: 20px;
                            font-weight: 400;" 
                            [(ngModel)]="model.endTimeC" #endTimeC="ngModel" [ngClass]="{ 'is-invalid': f.submitted && endTimeC.invalid }" required />
                            <div *ngIf="f.submitted && endTimeC.invalid" class="invalid-feedback">
                                <div *ngIf="endTimeC.errors.required">Start Time is required</div>
                            </div>

                            
                        </div>

                    </div>
                </div>
                    

                    <div class="form-group">
                        <!-- <label for="email">Email</label> -->
                        <input type="text" class="form-control" id="eventTitle" name="noteC" placeholder="Note"
                        
                        [(ngModel)]="model.noteC" #noteC="ngModel" [ngClass]="{ 'is-invalid': f.submitted && noteC.invalid }" required />
                        <div *ngIf="f.submitted && noteC.invalid" class="invalid-feedback">
                            <div *ngIf="noteC.errors.required">Note is required</div>
                        </div>
                    </div>
                    
                    <div class="form-group">     
                <button class="btnSend">
                <i class="fas fa-paper-plane" aria-hidden="true" style="color: #fff;"></i> &nbsp;
                 Send
                 </button>
                    </div>
                </form>
            </div>
        <!-- </div> -->
        <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle" style="font-weight: 500;font-size: 25px;"> Department Name</h5>
                
                <button type="button" class="close" data-dismiss="modal" (click)="getMemberListfor()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
             
              <div class="modal-body">
                <ng-multiselect-dropdown
                    name="deptment"
                    [placeholder]="'Select Department'"
                    [data]="departmentsList"
                    [(ngModel)]="model.erpDept"
                    [settings]="dropdownSettings"
                    (onSelect)="onItemSelect($event)"
                    (onDeSelect)="onItemDeSelect($event)"
                    >
                </ng-multiselect-dropdown>
              
              </div>     
              <div class="modal-footer">       
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="exampleModalCenter2" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle" style="font-weight: 500;font-size: 25px;">Group Name</h5>
                
                <button type="button" class="close" data-dismiss="modal" (click)="getGroupMemberListfor()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
             
              <div class="modal-body">
                <ng-multiselect-dropdown
                    name="Group"
                    [placeholder]="'Select Group'"
                    [data]="groupList"                   
                    [settings]="groupDropdownSettings"
                    (onSelect)="onGroupSelect($event)"
                    (onDeSelect)="onGroupDeSelect($event)"
                    >
                </ng-multiselect-dropdown>
              
              </div>     
              <div class="modal-footer">       
              </div>
            </div>
          </div>
        </div>
        


      
      
      </div>

         
    </div>




